module.exports = __webpack_public_path__ + "images/6cbdaae220e875bc76a292add17dfe5a-JungleExperiences.jpg";